export default __webpack_public_path__ + "static/100--stacked-column-3e6ce536e1a20b625be6fc0f2aad99c3.png";